import React from 'react';

export const s = {
    box: { border: "1px solid #ccc", marginBottom: 10, borderRadius: 4, boxSizing: "border-box", width: "100%", padding: 4, display: "flex", flexWrap: "wrap", justifyContent: "flex-end" },
    table: { display: "flex", gap: 4, width: "100%", alignItems: "center", padding: "0", marginBottom: 4, flexWrap: "wrap" },
    tableCell: { fontSize: 14, flex: 1, width: 100, textAlign: "left", overflow: "hidden", display: "block", whiteSpace: "nowrap" },
    th: { boxSizing: "border-box", padding: 4, gap: 10, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" },
    cell: i => ({ boxSizing: "border-box", padding: 4, gap: 10, width: "100%", backgroundColor: i % 2 === 0 ? "#f0f0f0" : "#f8f8f8", display: "flex", justifyContent: "space-between", alignItems: "center" }),
    input: { border: "none", fontSize: 12, flex: 1 },
    icon: { fontSize: 12, marginLeft: 10 },
    H2: ({ children }) => <h2 style={{ fontSize: 18, marginBottom: 10 }}>{children}</h2>,
    title3: { fontSize: 16 },
    BackArrow: ({ does }) => <i onClick={does} className="fas fa-arrow-left" style={{ marginRight: 6, fontSize: "inherit" }}></i>,
    ExitArrow: ({ does }) => <i onClick={does} className="fas fa-times" style={{ marginRight: 6, fontSize: "inherit" }}></i>,
    DownArrow: ({ does }) => <i onClick={does} className="fas fa-arrow-down" style={{ marginRight: 6, fontSize: "inherit" }}></i>,
    IconButton: ({ size = 12, does, icon, disabled, color, textColor }) => <span style={{ ...(color ? { backgroundColor: color, color: textColor } : {}), ...{ width: 24, height: 18, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", cursor: "pointer", borderRadius: 4, fontSize: size, border: "1px solid #ccc" } }}
        disabled={disabled} onClick={does}><i className={icon} style={{ cursor: "pointer", fontSize: size }}></i></span>,
    row: { display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 10, width: "100%", boxSizing: "border-box" },
    rowLeft: { display: "flex", alignItems: "flex-end", gap: 10, width: "100%", boxSizing: "border-box" },
    rowWrap: { display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-end", gap: 10, width: "100%", boxSizing: "border-box" },
    rowTop: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10, width: "100%", boxSizing: "border-box" },
    rowCenter: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, width: "100%", boxSizing: "border-box" },
    button: { marginBottom: 10, display: "inline-block", cursor: "pointer" },
    disabledButton: { border: "1px solid white", color: "gray", marginBottom: 10, display: "inline-block", cursor: "pointer" },
    borderlessButton: { border: "none", backgroundColor: "transparent", marginBottom: 10, fontSize: 14, cursor: "pointer" },
    bigButton: { minWidth: 180, padding: "10px 20px", fontSize: 16, margin: 0, borderRadius: 4, backgroundColor: "#303030", color: "white", border: "none", cursor: "pointer" },
    disabledBigButton: { minWidth: 180, padding: "10px 20px", fontSize: 16, margin: 0, borderRadius: 4, backgroundColor: "#00000050", color: "#33333380", border: "none", cursor: "pointer" },
    smallInput: { fontSize: 14, borderBottom: "none" },
    mobileContainer: { maxWidth: 500, paddingBottom: 200 },
    pinned: { boxShadow: "0 0 10px rgba(0,0,0,.1)", display: "flex", justifyContent: "space-between", borderTop: "1px solid #ccc", position: "fixed", boxSizing: "border-box", padding: "10px 10px 0", bottom: 0, left: 0, width: "100%", zIndex: 1000, backgroundColor: "white", borderBottom: "1px solid #ccc" },
    scrollMenuButton: selected => ({ border: "1px solid #333", background: selected ? "#303030" : "#fff", padding: "10px 20px", color: selected ? "#fff" : "#303030", fontSize: 14, textAlign: "center", borderRadius: 4, cursor: "pointer", whiteSpace: "nowrap", textDecoration: "none", boxShadow: selected ? "0 0 10px rgba(0,0,0,.1)" : "none" }),
    flexScroll: { display: "flex", overflowX: "auto", gap: 10, padding: "10px 0", marginBottom: 20, maxWidth: "100vw" },
    headerBox: { marginBottom: 60, padding: "80px 20px 10px 20px", boxShadow: "0 0 10px rgba(0,0,0,.1)", borderBottom: "1px solid #ccc", position: "sticky", top: 0 },
    headerInnerBox: { maxWidth: 1200, margin: "auto" },
    paddingContainer: { padding: "10px 20px 20px 20px", maxWidth: 1200, margin: "auto" },
    listItem: { borderTop: "0px solid #ccc", padding: "14px 0 10px", marginTop: 10 },
    menuItemStyle: { width: "80%", textAlign: "right", whiteSpace: "nowrap", fontSize: 14, border: 0, background: "#fff", padding: 0, marginBottom: 5, color: "#303030", textDecoration: "none" },
    topMenuItemStyle: { margin: 0, width: "auto", textAlign: "right", whiteSpace: "nowrap", fontSize: 14, border: 0, background: "#fff", padding: "0 10px", color: "#303030", textDecoration: "none" },
    vendorLinks: { display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center", padding: "20px 0" },
    vendorIntro: { width: "calc(50% - 10px)", textDecoration: "none", minWidth: 350, maxWidth: 500 },
    vendorLink: { width: "calc(25% - 10px)", textDecoration: "none", minWidth: 360 },
    vendorImage: { color: "black", width: "calc(100% - 20px)", margin: "10px", height: "140px", objectFit: "cover", boxShadow: "0 20px 20px -20px, 0 0 2px", borderRadius: "4px" },
    vendorName: { fontSize: "20px", color: "#777", lineHeight: "1.5", fontFamily: "'Nunito', sans-serif", margin: "0 0 40px", display: "block", textAlign: "center" },
    desktopScrollContainer: { overflowX: "auto", maxWidth: "100vw", paddingBottom: 0 },
    desktopContainer: { minWidth: 1200, margin: "auto" },
    orderBox: { padding: "10px", marginTop: 20, backgroundColor: "#fff", cursor: "pointer", display: "flex", gap: 4, flexDirection: "column", alignItems: "flex-start", borderRadius: 4, boxShadow: "0 10px 10px -14px rgba(0,0,0,1)", border: "1px solid #ccc", borderLeft: "10px solid #ccc", width: "100%", boxSizing: "border-box" },

    tabButton: selected => ({ fontWeight: selected ? 900 : 400, border: 0, background: "#fff", padding: 0, paddingRight: 10 }),
};

const Style = () => {

    return <style>{`

        body, html {
            margin: 0;
            font-family: 'Roboto', sans-serif;
            overflow-x: hidden;
            padding: 0px;
        }

        label {
            margin: 0;
            font-size: 12px;
        }

        .showonmobile{
            display: none !important;
        }

        .showontablet{
            display: none !important;
        }

        @media (max-width: 800px) {

            .hideontablet{
                display: none !important;
            }

            .wrapontablet{
                display: block !important;
            }

            .showontablet{
                display: block !important;
            }

        }

        @media (max-width: 600px) {

            .hideonmobile{
                display: none !important;
            }

            .wraponmobile{
                display: block !important;
            }

            .showonmobile{
                display: block !important;
            }

            .wrapflex{
                align-items: flex-start !important;
                flex-direction: column !important;
                box-sizing: border-box !important;
            }
            .wrapflex div{
                width: 100% !important;
            }
            .wrapflex input:not([type="checkbox"]), .wrapflex textarea{
                width: 100% !important;
                box-sizing: border-box !important;
            }

        }

        @keyframes flyup {
            0% { transform: translateY(200px);; }
            100% { transform: translateY(-100px);; }
        }
        .flyup {
            animation: flyup 1s forwards;
        }

    `}</style>;
}
export default Style;